import store from 'store'

const el = '[data-content=HoldOprettelseKvittering]'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((HoldOprettelseKvitteringDOM)=>{
            if(HoldOprettelseKvitteringDOM.dataset.teamid){
                const teamId = HoldOprettelseKvitteringDOM.dataset.teamid
                store.commit('main/set_page_overlay_content_data',{ teamId })
            }
        })
    }
}